export default () => ({
	init() {
		console.log('Footer')
	},
})
